import React, { useState } from 'react';
import { Bill } from '../types/Bill';
import { payBillWithPayPal, payBillWithStripe } from '../services/billingService';
import { useToast } from '../context/ToastContext';
import { Navigate } from 'react-router-dom';

const BillsTable: React.FC<{ bills: Bill[] | undefined }> = ({ bills }) => {
  const [expandedBill, setExpandedBill] = useState<string | null>(null);
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [selectedBill, setSelectedBill] = useState<Bill | null>(null);

  const toast = useToast();
  


  const toggleExpand = (billId: string) => {
    setExpandedBill(expandedBill === billId ? null : billId);
  };


  const showPaymentPopup = (bill: Bill) => {
    setSelectedBill(bill);
    setShowPopup(true);
  }

  const openStripe = async () => {
    if (selectedBill) {
      try {
      const url = await payBillWithStripe(selectedBill?.bill_id);
        if (url) {
          window.location.href = url;
        }
      } catch (error) {
        console.log(error);
        toast.addToast('Stripe error occurred. Please refresh the page and try again.', true);
      }
    } else {
      toast.addToast("No bill selected");
    }
  }

  const openPaypal = async () => {
    if (selectedBill) {
      await payBillWithPayPal(selectedBill?.bill_id, "NEED TO FIX");
    } else {
      toast.addToast("No bill selected");
    }
  }

  const closePopup = () => {
    setSelectedBill(null);
    setShowPopup(false);
  }

  return (
    <div className='tableWrapper'>
      {bills ? (<div>
        <table>
          <thead>
            <tr>
              <th>Event</th>
              <th>Original Amount</th>
              <th>Discount</th>
              <th>Total Amount</th>
              <th>Status</th>
              <th>Due Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {bills?.map((bill) => (
              <React.Fragment key={bill.bill_id}>
                <tr>
                  <td><button onClick={() => toggleExpand(bill.bill_id)}>
                      {expandedBill === bill.bill_id ? '▼' : '▶'}
                    </button>{`  ${bill.event?.event_name}` || '  N/A'}</td>
                    <td>${bill.original_amount}</td>
                    <td>{bill.discount_percentage && bill.discount_percentage > 0 
                         ? `${bill.discount_percentage}%` : ''}
                         {bill.discount_amount && bill.discount_amount > 0 
                         ? `$${bill.discount_amount}` : ''}
                         {((Number(bill.discount_percentage) ?? 0 == 0) && Number((bill.discount_amount) ?? 0 == 0)) ? '-' : ''}
                         </td>

                  <td><strong>${bill.total_amount}</strong></td>
                  <td>{bill.paid ? 'Paid' : 'Unpaid'}</td>
                  <td>{new Date(bill.due_date).toLocaleDateString()}</td>
                  <td>
                    { bill.paid ? 'Paid' : ''}
                    {(!bill.paid) && (<button className="actionButton" onClick={() => showPaymentPopup(bill)}>
                      Pay Now
                    </button>)}
                    {/* { (bill.event?.use_billing_service == false) && 'Billed By Host' } */}
                  </td>
                </tr>
                {expandedBill === bill.bill_id && (
                  <tr>
                    <td colSpan={7}>
                      <div>
                        <h3>{bill.details}</h3>
                        <h3>Payments</h3>
                        {bill.payments.length > 0 ? (
                          <table>
                            <thead>
                              <tr>
                                <th>Amount</th>
                                <th>Currency</th>
                                <th>Paid Date</th>
                                <th>Method</th>
                              </tr>
                            </thead>
                            <tbody>
                              {bill.payments.map((payment) => (
                                <tr key={payment.payment_id}>
                                  <td>${Number(payment.amount).toFixed(2)}</td>
                                  <td>{payment.currency}</td>
                                  <td>{new Date(payment.paid_date).toLocaleDateString()}</td>
                                  <td>{payment.payment_method || 'N/A'}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <p>No payments recorded for this bill.</p>
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>) : (<h3>No current bills.</h3>)}
      {showPopup && <div className="popOverBackdrop"></div>
      }
      {showPopup && (
        <div className="popOverContainer"
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            background: 'white',
            padding: '20px',
            border: '1px solid #ccc',
            borderRadius: '5px',
            zIndex: 1000,
            minWidth: '500px',
            maxHeight: '400px'
          }}>
            <h2>Pay Online with Stripe</h2>
            <h4>Selecting Stripe will open a new tab and take you outside the app.</h4>
            <div style={{display: 'flex', justifyContent: 'space-evenly', marginBottom: '20px'}}>
                {/* <div className="card">
                <h3>Pay With PayPal</h3>
                <button className="actionButton" onClick={openPaypal}>
                      Go to Paypal
                    </button>
                </div> */}
                <div className="card">
                    <h3>Pay With Stripe</h3>
                    <button className="actionButton" onClick={openStripe}>
                      Go to Stripe
                    </button>
                </div>
            </div>
            <div className="buttonsRow">
                <div className="buttonsLeft"></div>
                <button className="cancelButton" onClick={closePopup}>
                        Close and Pay Later
                </button>
            </div>
          </div>)}
    </div>
  );
};

export default BillsTable;
